// import { DragEndEvent } from '@dnd-kit/core';
// import { arrayMove } from '@dnd-kit/sortable';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// import {
//   PriorityProperties,
// } from '../../../interface/schedule-management.interface';
import { brandImage } from '../../../config/branding';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  changeDevicePointStatus,
  removeDevicePointStatus,
} from '../../../redux/slice/DeviceManagementSlice';
import MyButton from '../../../shared-components/button/Button';
import ModalBox from '../../../shared-components/modal-box/ModalBox';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotification';
import deviceApi from '../../../utils/api/device';

import ChargePoint from './ChargePoint';

interface ModalBoxDetail {
  title: string | null;
  content: JSX.Element | null;
  notificationModal: boolean;
}

// To-Do - Confirm eslint rule to move this function outside the scope
/**
 * Function to find the index of the element in the array
 * @param priorityArray
 * @param id
 * @returns index
 */
// const getElementPosition = (priorityArray: PriorityProperties[], id: string | number) => {
//   const priorityIndex = priorityArray.findIndex((priority) => priority.id === id);
//   return priorityIndex;
// };

/**
 * Point schedule availability component
 */
function ScheduleAvailability() {
  const { t, i18n } = useTranslation('scheduleManagement');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { devicePoints, deviceId } = useAppSelector((state) => state.device);

  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [modalBoxDetail, setModalBoxDetail] = useState<ModalBoxDetail>({
    title: '',
    content: null,
    notificationModal: false,
  });

  /**
   * Function to switch availability
   * @param id
   * @param value
   */
  const handleAvailabilityChange = (id: string, value: string) => {
    dispatch(
      changeDevicePointStatus({
        id,
        value,
      }),
    );
  };

  /**
   * Handle the submit function
   */
  const handleSubmitFunction = () => {
    const request = {
      connectors: devicePoints.map((value) => ({
        connectorId: value.connectorId,
        isReservationEnabled: value.isReservationEnabled,
      })),
    };
    deviceApi
      .editDeviceConnectPointsStatus(request, deviceId)
      .then(() => {
        dispatch(removeDevicePointStatus());

        setModalBoxStatus('open');
        setModalBoxDetail({
          title: null,
          content: (
            <SuccessNotification
              title={t('deviceAvailabilityChanged')}
              description={t('deviceAvailabilityChangedSuccess')}
              notificationCloseTimer={3000}
              onNotificationClose={() => setModalBoxStatus('close')}
            />
          ),
          notificationModal: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="schedule-availability-container" dir={i18n.dir()}>
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        modalBoxAnimation="modalAnimateToLeft"
        notification={modalBoxDetail.notificationModal}
        header={!modalBoxDetail.notificationModal}
      />
      <div className="schedule-availability-change-container">
        {devicePoints?.length > 0 ? (
          <ChargePoint
            singlePriority={devicePoints[0]}
            handleAvailabilityChange={handleAvailabilityChange}
          />
        ) : (
          <div />
        )}
        <div className="schedule-availability-device-image">
          <img
            src={
              devicePoints.length === 0
                ? brandImage.deviceWithoutConnectors
                : brandImage.deviceWithTwoConnectors
            }
            alt={t('chargingDevice')}
          />
        </div>
        {devicePoints?.length > 1 ? (
          <ChargePoint
            singlePriority={devicePoints[1]}
            handleAvailabilityChange={handleAvailabilityChange}
          />
        ) : (
          <div />
        )}
      </div>
      {devicePoints.length > 0 && (
        <div className="schedule-availability-change-button-wrap">
          <div className="schedule-back-button">
            <MyButton
              buttonType="back"
              label={t('cancel')}
              onClickFunc={() => {
                dispatch(removeDevicePointStatus());
                navigate('../schedule-management');
              }}
            />
          </div>
          <div className="schedule-save-button">
            <MyButton
              buttonType="submit"
              label={t('save')}
              onClickFunc={handleSubmitFunction}
              disableHoverEffect
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ScheduleAvailability;
